// App composition root (I-0a Batch 3): the app shell wrapped in an error
// boundary with a calm fallback (Implementation Plan v02 §5.1).

import { ErrorBoundary } from './shell/ErrorBoundary'
import { AppShell } from './shell/AppShell'

function CalmFallback(): React.JSX.Element {
  return (
    <div className="shell">
      <main className="shell__main">
        <h1 className="shell__title">Pebble</h1>
        <p className="shell__note">Something went wrong. Please reopen the app.</p>
      </main>
    </div>
  )
}

export function App(): React.JSX.Element {
  return (
    <ErrorBoundary fallback={<CalmFallback />}>
      <AppShell />
    </ErrorBoundary>
  )
}
